import { Select } from "antd";
import React from "react";
import "./DefaultSelect.css";

interface IOptionList {
	value: any;
	label: any;
}

interface IDefaultSelect {
	label?: string;
	value?: any;
	placeholder?: string;
	width?: number;
	allowClear?: boolean;
	labelInValue?: boolean;
	options?: IOptionList[];
	onChange?: (value: any) => void;
	flexDirection?: "row" | "col";
	alignCenter?: "center" | "start";
	className?: any;
	status?: any;
	style?: React.CSSProperties;
	onClear?: () => void;
	/** Fires on every pick, also when the selected option is picked again (onChange does not). */
	onSelect?: (value: any) => void;
	disabled?: boolean;
	onSearch?: any;
	mode?: any;
	/** Replaces the default match (lower case, accents count) for this select. */
	filterOption?: (input: string, option?: IOptionList) => boolean;
	/** For a list loaded page by page: the next page when scrolled to the bottom. */
	onPopupScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
	onDropdownVisibleChange?: (open: boolean) => void;
}

const DefaultSelect = ({
	label,
	placeholder,
	value,
	width,
	options,
	onChange,
	flexDirection = "row",
	alignCenter = "center",
	className,
	onClear,
	allowClear,
	labelInValue = false,
	status,
	style,
	disabled,
	onSearch,
	mode,
	filterOption: customFilterOption,
	onPopupScroll,
	onDropdownVisibleChange,
	onSelect,
}: IDefaultSelect) => {
	const defaultFilterOption = (
		input: string,
		option?: { label: string; value: string }
	) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
	const filterOption = customFilterOption ?? defaultFilterOption;

	return (
		<div
			className={`flex flex-${flexDirection} items-${alignCenter} gap-1 `}
		>
			<label className="-mb-1">{label}</label>
			<Select
				labelInValue={labelInValue}
				showSearch
				allowClear={allowClear}
				placeholder={placeholder}
				options={options}
				onChange={onChange}
				value={value}
				className={`default-select ${className}`}
				onClear={onClear}
				status={status}
				style={style}
				filterOption={filterOption}
				disabled={disabled}
				onSearch={onSearch}
				onPopupScroll={onPopupScroll}
				onDropdownVisibleChange={onDropdownVisibleChange}
				onSelect={onSelect}
				mode={mode}
				maxTagCount="responsive"
			/>
		</div>
	);
};

export default DefaultSelect;
